(() => {
  if (window.incFormsDismissInstalled) return;
  window.incFormsDismissInstalled = true;
  const observed = new WeakSet();

  function connect(host) {
    const root = host.shadowRoot;
    if (!root || observed.has(root)) return;
    observed.add(root);
    let allowDismiss = false;

    function guardDismiss(event) {
      const dialog = root.querySelector('section[data-sizing="form-wrapper"][role="dialog"]');
      if (!dialog?.querySelector('[data-testid="btn-form-submit"]') || !dialog.getClientRects().length || allowDismiss) return;
      const path = event.composedPath();
      const close = dialog.querySelector('[role="button"][aria-label="Close modal"]');
      const dismiss = dialog.querySelector('[data-inc-dismiss]');
      const blockedKey = event.type === 'keydown' && event.key === 'Escape';
      const blockedPointer = event.type !== 'keydown' &&
        (!path.includes(dialog) || (close && path.includes(close)));
      if (!blockedKey && !blockedPointer) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (blockedKey) dismiss?.focus();
    }

    for (const type of ['pointerdown', 'pointerup', 'mousedown', 'mouseup', 'touchstart', 'touchend', 'click', 'keydown']) {
      window.addEventListener(type, guardDismiss, {capture: true, passive: false});
    }

    function update() {
      const dialog = root.querySelector('section[data-sizing="form-wrapper"][role="dialog"]');
      const submit = dialog?.querySelector('[data-testid="btn-form-submit"]');
      const close = dialog?.querySelector('[role="button"][aria-label="Close modal"]');
      if (!dialog || !close) return;
      if (!submit) {
        close.removeAttribute('data-inc-native-close');
        dialog.querySelector('[data-inc-dismiss]')?.remove();
        return;
      }

      let button = dialog.querySelector('[data-inc-dismiss]');
      if (!button) {
        button = document.createElement('button');
        button.type = 'button';
        button.dataset.incDismiss = 'true';
        button.textContent = 'Não gosto de surpresas';
        button.style.cssText = 'display:block;width:100%;background:transparent;border:0;padding:10px 6px;margin-top:4px;color:#666;font:inherit;font-size:13px;text-decoration:underline;cursor:pointer;line-height:1.4;';
        button.addEventListener('click', () => {
          allowDismiss = true;
          try {
            dialog.querySelector('[role="button"][aria-label="Close modal"]')?.click();
          } finally {
            allowDismiss = false;
          }
        });
        submit.insertAdjacentElement('afterend', button);
      }
      if (!root.querySelector('[data-inc-dismiss-style]')) {
        const style = document.createElement('style');
        style.dataset.incDismissStyle = 'true';
        style.textContent = '[data-inc-native-close]{display:none!important} [data-inc-dismiss]:focus-visible{outline:2px solid currentColor;outline-offset:2px}';
        root.appendChild(style);
      }
      if (!close.hasAttribute('data-inc-native-close')) {
        if (root.activeElement === close) button.focus();
        close.setAttribute('data-inc-native-close', '');
      }
    }

    new MutationObserver(update).observe(root, {childList:true,subtree:true});
    update();
  }

  function scan() {
    document.querySelectorAll('shopify-forms-embed').forEach(connect);
  }

  new MutationObserver(scan).observe(document.documentElement, {childList:true,subtree:true});
  const timer = setInterval(scan, 500);
  setTimeout(() => clearInterval(timer), 30000);
  scan();
})();